import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Mixpanel } from '../../utils/mixpanel';
export class TouchableOpacityLink extends Component {
    render() {
        return (
            <Link {...this.props} onClick={() => this.handleClick(window.location.pathname)} />
        );
    }

    handleClick = (location) => {
        try {
            Mixpanel.track('Page link clicked', { 'pagename': this.props.to, 'from_page': location });
        }
        catch (error) {
            console.log("mix panel trackin error =>", error);
        }
        if (this.props.handleClick) {
            this.props.handleClick(location, this.props.to);
        }
    }
}

export default TouchableOpacityLink;